import { SelectField } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { apiClient } from '../../../../../../api';

type Props = {
  stationId: string;
  label: string;
  name: string;
  multiple?: boolean;
  markRequired?: boolean;
};

export const AudioSelect = ({ stationId, label, name, multiple = true, markRequired }: Props) => {
  const { $t } = useIntl();

  return (
    <SelectField
      label={label}
      name={name}
      placeholder={$t({
        id: 'audit.scheduleStatusScreen.filter.idPlaceholder',
        defaultMessage: 'Todos',
      })}
      options={[] as { customId: string }[]}
      getOptionValue={(m: { customId: string }) => m.customId}
      getOptionLabel={(m: { customId: string }) => m.customId}
      loadOptions={async (customId) => {
        const { results } = await apiClient.audit.fetchAudios({
          stationId,
          select: ['id', 'duration', 'customId'],
          filter: {
            customIdLike: `%${customId}%`,
          },
        });

        return results;
      }}
      multiple={multiple}
      markRequired={markRequired}
    />
  );
};
